exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ui.form .fields.TableForm__checkGroup{justify-content:space-around;margin-bottom:1.5em}.ui.form .fields.TableForm__checkGroup .checkbox{margin-bottom:1em}", ""]);

